"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var FormGroup = function FormGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      inline = _ref.inline,
      error = _ref.error;
  var classes = (0, _classnames.default)('FormGroup', {
    'FormGroup-inline': inline
  }, {
    'FormGroup-contains-error': error
  }, className);
  return _react.default.createElement("div", {
    className: classes
  }, children, error);
};

FormGroup.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The element(s) to render. */
  children: _propTypes.default.node.isRequired,

  /** Whether the elements in this group should be rendered inline. */
  inline: _propTypes.default.bool,

  /** A custom validation error (typically a FormGroupError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element
};
var _default = FormGroup;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FormGroup, "FormGroup", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Form/FormGroup.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Form/FormGroup.jsx");
  leaveModule(module);
})();

;